export const CATEGORY_ID = '934';

export const BATHROOM_REPAIR_LANDING_NAME = 'bathroom-repair';

export const BATHROOM_REPAIR_PATH = '/uslugi/remont-vannoy-komnaty/';

export const BATHROOM_REPAIR_CDN_PATH =
  'https://cdn.lemanapro.ru/lmru/image/upload/f_auto,c_pad,b_auto,d_photoiscoming.png/fudzi/elbrus/images/landings/bathroom-repair';

export const BATHROOM_REPAIR_ELEMENT_BLOCK = 'landingRemontVannuyu';

export const BATHROOM_REPAIR_SIGN_UP_HREF = '/zapis-onlayn/?department_no=6&region_id=';
